<script>
import devData from './dev-data/weekly-milling-qty.json'
import api from '@/helpers/api'
import { sumBy, chain, meanBy } from 'lodash'
import moment from 'moment'

export default {
  name: 'weekly-milling-avg.card.card',
  data () {
    return {
      quantity: 0,
      trend: 0,
      prevTrend: 0,
      trendUp: true,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          sparkline: {
            enabled: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 0.3
        },
        fill: {
          opacity: 0.5
        },
        yaxis: {
          min: 0
        },
        xaxis: {
          type: 'text'
        },
        colors: ['#365671']
      }
    }
  },
  mounted () {
    this.onRefresh()
  },
  methods: {
    async onRefresh () {
      var result = []
      if (process.env.NODE_ENV !== 'production') {
        result = devData
      } else {
        var start_date = moment().startOf('year').format('MM/DD/YYYY')
        var end_date = moment().endOf('year').format('MM/DD/YYYY')
        result = await api.stats.weeklyQuantityByTag({
          start_date,
          end_date,
          tag: 'stat_qty_milling'
        })
      }

      var thisWeek = moment().startOf('isoWeek')
      var lastWeek = moment(thisWeek).subtract(1, 'month')

      var grouped = chain(result)
        .groupBy(x => moment(x.start_date).startOf('isoWeek'))
        .map((data, id) => ({
          start_date: id,
          value: sumBy(data, 'quantity')
        }))
        .value()

      this.quantity = meanBy(grouped, 'value').toFixed(0)

      this.prevTrend = meanBy(
        grouped.filter(x => moment(x.start_date).isBefore(lastWeek)),
        'value'
      ).toFixed(0)

      var trend = ((this.quantity / this.prevTrend - 1) * 100).toFixed(0)
      if (this.prevTrend === 0) trend = 0

      this.trend = Math.abs(trend)
      this.trendUp = trend > 0
    }
  }
}
</script>
<template>
  <b-card no-body>
    <b-card-body>
      <div>
        <h4 class="mb-1 mt-1">
          {{ quantity }}
        </h4>
        <p class="text-muted mb-0">{{ $t('Avg Weekly Millings') }}</p>
      </div>
      <p class="text-muted mt-3 mb-0">
        <span
          class="m-1"
          :class="[{ 'text-success': trendUp }, { 'text-danger': !trendUp }]"
        >
          <i
            class="mdi me-1"
            :class="[
              { 'mdi-arrow-up-bold': trendUp },
              { 'mdi-arrow-down-bold': !trendUp }
            ]"
          ></i
          >{{ trend }}%
        </span>
        since last week <span class="font-size-xs">({{ prevTrend }})</span>
      </p>
    </b-card-body>
  </b-card>
</template>
